import { Target, BookOpen, Calculator, MessageCircle, TrendingUp, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Features = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Target, titleKey: "features.1.title", descKey: "features.1.desc" },
    { icon: BookOpen, titleKey: "features.2.title", descKey: "features.2.desc" },
    { icon: Calculator, titleKey: "features.3.title", descKey: "features.3.desc" },
    { icon: MessageCircle, titleKey: "features.4.title", descKey: "features.4.desc" },
    { icon: TrendingUp, titleKey: "features.5.title", descKey: "features.5.desc" },
    { icon: MapPin, titleKey: "features.6.title", descKey: "features.6.desc" },
  ];

  return (
    <section className="py-24 bg-ink-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="eyebrow mb-4">{t("eyebrow.features")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-white mb-4">{t("features.title")}</h2>
          <p className="text-lg text-white/60">{t("features.sub")}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="bg-ink-700 border border-white/[0.06] p-7 rounded-3xl hover:border-violet/40 hover:-translate-y-1 transition-all duration-300">
              <div className="w-11 h-11 rounded-xl bg-violet/15 flex items-center justify-center mb-5">
                <feature.icon className="h-5 w-5 text-violet" />
              </div>
              <h3 className="font-display text-2xl text-white mb-2">{t(feature.titleKey)}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{t(feature.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
